export const CATEGORY_ACTION_TYPES = {
    FETCH_CATEGORIES_START: "FETCH_CATEGORIES_START",
    FETCH_CATEGORIES_SUCCESS: "FETCH_CATEGORIES_SUCCESS",
    FETCH_CATEGORIES_FAILED: "FETCH_CATEGORIES_FAILED"
}